"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutatingHierachyAssemblerImpl = void 0;
var HierarchyAssembler_1 = require("./HierarchyAssembler");
var MutatingHierachyAssemblerImpl = /** @class */ (function () {
    function MutatingHierachyAssemblerImpl(mutationFunction) {
        this.mutationFunction = mutationFunction;
    }
    MutatingHierachyAssemblerImpl.prototype.assembleChildren = function (rootItem, content) {
        var _a;
        var _this = this;
        (_a = rootItem.children).push.apply(_a, content
            .filter(function (contentItem) {
            return (0, HierarchyAssembler_1.isParent)(rootItem.content, contentItem.content);
        })
            .map(function (item) {
            var hierarchyItem = {
                content: _this.mutationFunction(item.content),
                children: [],
            };
            _this.assembleChildren(hierarchyItem, content);
            return hierarchyItem;
        }));
    };
    MutatingHierachyAssemblerImpl.prototype.assembleRoot = function (rootItem, content) {
        var _this = this;
        var rootHierarchyItem = {
            content: this.mutationFunction(rootItem.toJSON()),
            children: [],
        };
        rootHierarchyItem.children = content
            .filter(function (contentItem) {
            return (0, HierarchyAssembler_1.isParent)(rootItem.body, contentItem.content);
        })
            .map(function (item) {
            var hierarchyItem = {
                content: _this.mutationFunction(item.content),
                children: [],
            };
            _this.assembleChildren(hierarchyItem, content);
            return hierarchyItem;
        });
        return rootHierarchyItem;
    };
    return MutatingHierachyAssemblerImpl;
}());
exports.MutatingHierachyAssemblerImpl = MutatingHierachyAssemblerImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTXV0YXRpbmdIaWVyYXJjaHlBc3NlbWJsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvbGliL2NvbnRlbnQvY29vcmRpbmF0b3JzL0dldEJ5SGllcmFyY2h5L2Fzc2VtYmxlcnMvTXV0YXRpbmdIaWVyYXJjaHlBc3NlbWJsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkRBQW9FO0FBUXBFO0lBRUUsdUNBQ21CLGdCQUFnRDtRQUFoRCxxQkFBZ0IsR0FBaEIsZ0JBQWdCLENBQWdDO0lBQ2hFLENBQUM7SUFDSix3REFBZ0IsR0FBaEIsVUFDRSxRQUFvQyxFQUNwQyxPQUF5Qzs7UUFGM0MsaUJBa0JDO1FBZEMsQ0FBQSxLQUFBLFFBQVEsQ0FBQyxRQUFRLENBQUEsQ0FBQyxJQUFJLFdBQ2pCLE9BQU87YUFDUCxNQUFNLENBQUMsVUFBQyxXQUFXO1lBQ2xCLE9BQU8sSUFBQSw2QkFBUSxFQUFDLFFBQVEsQ0FBQyxPQUFPLEVBQUUsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ3pELENBQUMsQ0FBQzthQUNELEdBQUcsQ0FBQyxVQUFDLElBQUk7WUFDUixJQUFNLGFBQWEsR0FBOEI7Z0JBQy9DLE9BQU8sRUFBRSxLQUFJLENBQUMsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQztnQkFDNUMsUUFBUSxFQUFFLEVBQUU7YUFDYixDQUFDO1lBQ0YsS0FBSSxDQUFDLGdCQUFnQixDQUFDLGFBQWEsRUFBRSxPQUFPLENBQUMsQ0FBQztZQUM5QyxPQUFPLGFBQWEsQ0FBQztRQUN2QixDQUFDLENBQUMsRUFDSjtJQUNKLENBQUM7SUFFRCxvREFBWSxHQUFaLFVBQ0UsUUFBMkIsRUFDM0IsT0FBeUM7UUFGM0MsaUJBc0JDO1FBbEJDLElBQU0saUJBQWlCLEdBQStCO1lBQ3BELE9BQU8sRUFBRSxJQUFJLENBQUMsZ0JBQWdCLENBQUMsUUFBUSxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBQ2pELFFBQVEsRUFBRSxFQUFFO1NBQ2IsQ0FBQztRQUNGLGlCQUFpQixDQUFDLFFBQVEsR0FBRyxPQUFPO2FBQ2pDLE1BQU0sQ0FBQyxVQUFDLFdBQVc7WUFDbEIsT0FBTyxJQUFBLDZCQUFRLEVBQUMsUUFBUSxDQUFDLElBQUksRUFBRSxXQUFXLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDdEQsQ0FBQyxDQUFDO2FBQ0QsR0FBRyxDQUFDLFVBQUMsSUFBSTtZQUNSLElBQU0sYUFBYSxHQUErQjtnQkFDaEQsT0FBTyxFQUFFLEtBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDO2dCQUM1QyxRQUFRLEVBQUUsRUFBRTthQUNiLENBQUM7WUFDRixLQUFJLENBQUMsZ0JBQWdCLENBQUMsYUFBYSxFQUFFLE9BQU8sQ0FBQyxDQUFDO1lBQzlDLE9BQU8sYUFBYSxDQUFDO1FBQ3ZCLENBQUMsQ0FBQyxDQUFDO1FBRUwsT0FBTyxpQkFBaUIsQ0FBQztJQUMzQixDQUFDO0lBQ0gsb0NBQUM7QUFBRCxDQUFDLEFBaERELElBZ0RDO0FBaERZLHNFQUE2QiJ9